module.exports = __webpack_public_path__ + "static/media/599702_3.bb105efe.pdf";